/**
 * Workflow GraphQL queries (9 total — includes WorkflowGraph DAG queries).
 */
import { gql } from '@apollo/client';
import { WORKFLOW_FIELDS_FRAGMENT } from './fragments';

export const GET_WORKFLOW = gql`
  ${WORKFLOW_FIELDS_FRAGMENT}
  query GetWorkflow($tenantId: String!, $workflowId: String!) {
    getWorkflow(tenantId: $tenantId, workflowId: $workflowId) {
      ...WorkflowDetailFields
    }
  }
`;

export const LIST_WORKFLOWS = gql`
  ${WORKFLOW_FIELDS_FRAGMENT}
  query ListWorkflows($limit: Int, $cursor: String) {
    listWorkflows(limit: $limit, cursor: $cursor) {
      items {
        ...WorkflowDetailFields
      }
      totalCount
      hasNextPage
    }
  }
`;

export const LIST_WORKFLOWS_BY_STRATEGY = gql`
  ${WORKFLOW_FIELDS_FRAGMENT}
  query ListWorkflowsByStrategy($tenantId: String!, $strategy: String!) {
    listWorkflowsByStrategy(tenantId: $tenantId, strategy: $strategy) {
      ...WorkflowDetailFields
    }
  }
`;

export const LIST_ACTIVE_WORKFLOWS = gql`
  ${WORKFLOW_FIELDS_FRAGMENT}
  query ListActiveWorkflows($tenantId: String!) {
    listActiveWorkflows(tenantId: $tenantId) {
      ...WorkflowDetailFields
    }
  }
`;

export const LIST_LIFE_CRITICAL_WORKFLOWS = gql`
  ${WORKFLOW_FIELDS_FRAGMENT}
  query ListLifeCriticalWorkflows($tenantId: String!) {
    listLifeCriticalWorkflows(tenantId: $tenantId) {
      ...WorkflowDetailFields
    }
  }
`;

export const VALIDATE_WORKFLOW = gql`
  query ValidateWorkflow($tenantId: String!, $workflowId: String!) {
    validateWorkflow(tenantId: $tenantId, workflowId: $workflowId) {
      valid
      errors
      warnings
    }
  }
`;

export const GET_WORKFLOW_STATISTICS = gql`
  query GetWorkflowStatistics($tenantId: String!) {
    getWorkflowStatistics(tenantId: $tenantId) {
      totalWorkflows
      activeWorkflows
      lifeCriticalWorkflows
      totalInstantiations
      avgCompletionRate
    }
  }
`;

/** DAG canvas query — fetch a single WorkflowGraph by its graphId. */
export const GET_WORKFLOW_GRAPH = gql`
  query GetWorkflowGraph($tenantId: String!, $graphId: String!) {
    getWorkflowGraph(tenantId: $tenantId, graphId: $graphId) {
      graphId
      graphName
      description
      metadata
      nodes {
        id
        label
        nodeType
        x
        y
        description
        metadata
        approvalPolicyId
        subgraphId
        taskTemplateId
      }
      edges {
        id
        source
        target
        label
        condition
      }
      createdAt
      createdBy
      updatedAt
      updatedBy
    }
  }
`;

/**
 * DAG canvas query — list WorkflowGraphs for a tenant, optionally filtered by
 * graphName. Used to find the graph associated with a Workflow definition when
 * loading it into the designer canvas.
 */
export const LIST_WORKFLOW_GRAPHS = gql`
  query ListWorkflowGraphs($tenantId: String!, $graphName: String) {
    listWorkflowGraphs(
      tenantId: $tenantId
      filter: { graphName: $graphName }
    ) {
      graphs {
        graphId
        graphName
        description
        metadata
        nodes {
          id
          label
          nodeType
          x
          y
          description
          metadata
          approvalPolicyId
          subgraphId
          taskTemplateId
        }
        edges {
          id
          source
          target
          label
          condition
        }
        createdAt
        createdBy
        updatedAt
        updatedBy
      }
      totalCount
    }
  }
`;
